export const effigenColor = "/android-chrome-192x192.png";
export const effigenBlack = "/transp-black-1290x.png";
